window.emersonTurnstileCallback = function (token) {
  var input = document.getElementById('cf-turnstile-response')
  if (input) input.value = token
}

window.emersonTurnstileExpired = function () {
  var input = document.getElementById('cf-turnstile-response')
  if (input) input.value = ''
}

window.emersonTurnstileError = function () {
  var input = document.getElementById('cf-turnstile-response')
  if (input) input.value = ''
}

function resetEmersonTurnstile () {
  if (window.turnstile && document.querySelector('.cf-turnstile')) {
    try {
      window.turnstile.reset()
    } catch (e) {
      /* noop */
    }
  }
  var input = document.getElementById('cf-turnstile-response')
  if (input) input.value = ''
}

jQuery(function ($) {
  /**
   * Map warranty registration product codes → Shopify product IDs
   * (must match BV catalog / PDP data-bv-product-id values).
   */
  const bvProductMap = {
    'ES-1003-10QT': {
      id: '8932296720678',
      handle: 'emerson-smartvoice-air-fryer-10qt-1003a',
      title: 'Emerson SmartVoice 10QT Air Fryer ES1003'
    },
    'ES-5503-5QT': {
      id: '8932296753446',
      handle: 'emerson-smartvoice-air-fryer-5-3qt-5503a',
      title: 'Emerson SmartVoice 5.3QT Air Fryer ES5503'
    },
    '513-single': {
      id: '10133963538726',
      handle: 'emerson-smartvoice-single-wall-plug-es513',
      title: 'Emerson SmartVoice Wall Plug ES513'
    },
    '521-dual': {
      id: '10137996689702',
      handle: 'emerson-smartvoice-dual-wall-plug-es521',
      title: 'Emerson SmartVoice Dual Wall Plug ES521'
    },
    '522-dual-usb': {
      id: '10138002325798',
      handle: 'emerson-smartvoice-4-in-1-wall-plug-es522-usb-a',
      title: 'Emerson SmartVoice Wall Plug ES522'
    },
    '523-dual-usb-c': {
      id: '10225261248806',
      handle: 'emerson-smartvoice-4-in-1-wall-plug-es523-usb-a-c',
      title: 'Emerson SmartVoice Wall Plug ES523'
    },
    'ES4201-42': {
      id: '8932294164774',
      handle: 'emerson-smartvoice-42-tower-fan-e4201r',
      title: 'Emerson SmartVoice 42” Tower Fan ES4201'
    },
    'ES4007-40': {
      id: '8934072385830',
      handle: 'emerson-smartvoice-40-tower-fan-e4007r',
      title: 'Emerson SmartVoice 40” Tower Fan ES4007'
    },
    'ES2907-29': {
      id: '10133939093798',
      handle: 'emerson-smartvoice-29-tower-fan-es2907r',
      title: 'Emerson SmartVoice 29” Tower Fan ES2907'
    },
    'ES200ER-25': {
      id: '8934064816422',
      handle: 'emerson-smartvoice-tower-heater-es200er-v2',
      title: 'Emerson SmartVoice Tower Heater ES200ER'
    },
    'ES200FR-32': {
      id: '10133936734502',
      handle: 'emerson-smartvoice-tower-heater-es200fr-v2',
      title: 'Emerson SmartVoice Tower Heater ES200FR'
    },
    'ES204-headphones': {
      id: '10589550641446',
      handle: 'emerson-noisezero-open-ear-earphones',
      title: 'Emerson NoiseZero Open-Ear Earphones'
    }
  }

  const currentUrl = window.location.href
  const url = new URL(currentUrl)
  const queryParams = new URLSearchParams(url.search)
  const success = queryParams.get('success')

  function mountBazaarvoiceReview (registrationData) {
    const mapped = bvProductMap[registrationData && registrationData.productValue]
    const $bvMount = $('#bv-warranty-review')
    const $fallback = $('#bv-warranty-review-fallback')
    const $widgets = $('#bv-warranty-widgets')

    if (!mapped) {
      $bvMount.prop('hidden', true)
      $fallback.prop('hidden', false)
      return
    }

    $fallback.prop('hidden', true)
    $bvMount.prop('hidden', false)
    $('#bv-warranty-product-name').text(mapped.title)

    const productUrl = '/products/' + mapped.handle + '#product-reviews'
    $widgets.empty()

    const $summary = $('<div>', {
      class: 'bazaarvoice-rating-summary',
      'data-bv-show': 'rating_summary',
      'data-bv-product-id': mapped.id,
      'data-bv-redirect-url': productUrl
    })
    const $reviews = $('<div>', {
      class: 'bazaarvoice-reviews',
      'data-bv-show': 'reviews',
      'data-bv-product-id': mapped.id
    })
    $widgets.append($summary, $reviews)

    $('#bv-warranty-pdp-link').attr('href', productUrl).show()

    // Hosted Display usually observes new data-bv-show nodes; force a light remount if needed
    try {
      if (window.BV && window.BV.reviews && typeof window.BV.reviews.render === 'function') {
        window.BV.reviews.render()
      }
    } catch (e) {
      /* noop — rating summary stars / Write a review still work via PDP link */
    }
  }

  if (success) {
    $('#registration-form-section').hide()
    $('#thank-you-section').show()

    let data = null
    const registrationData = sessionStorage.getItem('emerson_registration_data')
    if (registrationData) {
      try {
        data = JSON.parse(registrationData)
        window.emersonRegistrationData = data
      } catch (e) {
        console.log('Error parsing registration data:', e)
      }
    }

    const skuFromQuery = queryParams.get('sku')
    if ((!data || !data.productValue) && skuFromQuery) {
      data = Object.assign({}, data || {}, { productValue: skuFromQuery })
    }

    if (data && data.productValue) {
      mountBazaarvoiceReview(data)
    } else {
      $('#bv-warranty-review-fallback').prop('hidden', false)
    }
  }

  const productOptions = {
    'air-fryers': [
      { value: 'ES-1003-10QT', text: 'ES 1003 10 qt' },
      { value: 'ES-5503-5QT', text: 'ES 5503 5 QT' }
    ],
    'smart-plugs': [
      { value: '513-single', text: '513 single' },
      { value: '521-dual', text: '521 dual' },
      { value: '522-dual-usb', text: '522 dual usb' },
      { value: '523-dual-usb-c', text: '523 dual usb c' }
    ],
    'tower-fans': [
      { value: 'ES4201-42', text: 'ES4201 42"' },
      { value: 'ES4007-40', text: 'ES4007 40"' },
      { value: 'ES2907-29', text: 'ES2907 29"' }
    ],
    'heaters': [
      { value: 'ES200ER-25', text: 'ES200ER 25"' },
      { value: 'ES200FR-32', text: 'ES200FR 32"' }
    ],
    'audio': [
      { value: 'ES204-headphones', text: 'ES204 Headphones' }
    ]
  }

  $('#category').on('change', function () {
    const category = $(this).val()
    const $productSelect = $('#product')
    const $productOther = $('#productOther')

    $productSelect.empty().prop('disabled', true)
    $productOther.hide().prop('required', false).val('')

    if (category && productOptions[category]) {
      $productSelect.append('<option value="">Select a product</option>')

      productOptions[category].forEach(function (product) {
        $productSelect.append('<option value="' + product.value + '">' + product.text + '</option>')
      })

      $productSelect.append('<option value="other">Other (Product not in list)</option>')
      $productSelect.prop('disabled', false)
    }
  })

  $('#product').on('change', function () {
    const productValue = $(this).val()
    const $productOther = $('#productOther')

    if (productValue === 'other') {
      $productOther.show().prop('required', true)
      $productOther.attr('aria-required', 'true')
    } else {
      $productOther.hide().prop('required', false).val('')
      $productOther.removeAttr('aria-required')
    }
  })

  $('#warranty-registration-form').on('submit', function (event) {
    event.preventDefault()

    if (!$('input[name="terms"]').is(':checked')) {
      alert('Please agree to the Terms And Conditions And Privacy Policy')
      return false
    }

    const productValue = $('#product').val()
    if (!productValue) {
      alert('Please select a product')
      return false
    }

    if (productValue === 'other') {
      const otherProduct = $('#productOther').val().trim()
      if (!otherProduct) {
        alert('Please enter the product name')
        return false
      }
    }

    if ($('#warranty-registration-form').data('turnstile-enabled')) {
      const turnstileToken = $('#cf-turnstile-response').val()
      if (!turnstileToken) {
        alert('Please complete the security check before submitting.')
        return false
      }
    }

    $('#warranty-registration-form .emerson-form-field-submit').prop('disabled', true)
    $('#warranty-registration-form .emerson-form-field-submit').val('Submitting...')

    const formData = new FormData(this)
    const email = $('#email').val()

    if (productValue === 'other') {
      formData.set('product', $('#productOther').val())
    }

    $.ajax({
      url: 'https://warranty.emersonsmart.com/warraty_registration.php',
      type: 'POST',
      data: formData,
      contentType: false,
      processData: false,
      success: function () {
        const registrationData = {
          firstName: $('#firstName').val(),
          lastName: $('#lastName').val(),
          email: $('#email').val(),
          category: $('#category option:selected').text(),
          product: productValue === 'other' ? $('#productOther').val() : $('#product option:selected').text(),
          productValue: productValue === 'other' ? $('#productOther').val() : productValue,
          categoryValue: $('#category').val(),
          timestamp: new Date().toISOString()
        }
        sessionStorage.setItem('emerson_registration_data', JSON.stringify(registrationData))

        const firstName = $('#firstName').val()
        const lastName = $('#lastName').val()
        const categoryText = $('#category option:selected').text()
        const productText = productValue === 'other' ? $('#productOther').val() : $('#product option:selected').text()

        if (typeof _learnq !== 'undefined' && email) {
          try {
            _learnq.push(['identify', {
              '$email': email,
              '$first_name': firstName,
              '$last_name': lastName,
              'Category': categoryText,
              'Product': productText
            }])
          } catch (e) {
            console.warn('Klaviyo tracking error:', e)
          }
        }

        setTimeout(function () {
          const skuParam = productValue === 'other' ? '' : ('&sku=' + encodeURIComponent(productValue))
          window.location.href = '/pages/emerson-warranty-register/?success=1' + skuParam
        }, 600)
      },
      error: function (xhr) {
        if (xhr && xhr.status === 403) {
          alert('Security check failed. Please try again.')
        } else {
          alert('There was an error submitting the form. Please try again.')
        }
        resetEmersonTurnstile()
      },
      complete: function () {
        $('#warranty-registration-form .emerson-form-field-submit').prop('disabled', false)
        $('#warranty-registration-form .emerson-form-field-submit').val('Submit')
      }
    })
  })
})
